export default {"src":"/_next/static/media/eng.32fe3e2b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};